import React from 'react';
import Helmet from 'react-helmet';
import find from 'lodash.find';

const metaData = [
    {
        pagename: 'Stock Funds',
        data: {
            desc:
                'Whether you’re looking for a core fund for your portfolio or want to diversify internationally, we offer a range of stock mutual funds to pursue your goals.',
            title: 'Stock Mutual Funds | T. Rowe Price'
        }
    },
    {
        pagename: 'Bond Funds',
        data: {
            desc:
                'Whether you are looking to complement a stock portfolio or to diversify internationally, we have a broad range of bond funds to fit your investing style.',
            title: 'Bond Funds | Mutual Funds | T. Rowe Price'
        }
    },
    {
        pagename: 'Money Market Funds',
        data: {
            desc:
                'Complement your portfolio with lower-risk money market funds. Learn about money market mutual funds by T. Rowe Price, and choose from over a dozen options.',
            title:
                'Money Market Funds | Money Market Mutual Funds | T. Rowe Price'
        }
    },
    {
        pagename: 'Asset Allocation Funds',
        data: {
            desc:
                'Asset allocation funds provide diversified portfolio solutions by mixing stocks and bonds in a single low-cost mutual fund.',
            title: 'Asset Allocation Funds | Mutual Funds | T. Rowe Price'
        }
    },
    {
        pagename: 'Morningstar 4- & 5-Star Rated Funds',
        data: {
            desc:
                'Explore T. Rowe Price Mutual Funds that have received 4- or 5-star overall ratings from Morningstar. Learn more about our strategic investing approach.',
            title:
                'Morningstar Rated Mutual Funds: 4 and 5-Star Funds | T. Rowe Price'
        }
    },
    {
        pagename: 'Target Date Funds',
        data: {
            desc:
                'Our target date, retirement, and income funds are a convenient way to get a diversified portfolio that you can carry to and through retirement.',
            title:
                'Target Date Funds: Retirement and Income Funds | T. Rowe Price'
        }
    },
    {
        pagename: 'Historical Performance',
        data: {
            desc:
                'Get detailed information on T. Rowe Price mutual fund investment performance, along with fees and expenses.',
            title: 'Historical Performance | Mutual Funds | T. Rowe Price'
        }
    },
    {
        pagename: 'Daily Prices',
        data: {
            desc: 'View daily closing prices for T. Rowe Price mutual funds.',
            title: 'Daily Prices | Mutual Funds | T. Rowe Price'
        }
    },
    {
        pagename: 'Select Funds',
        data: {
            desc:
                'Established, diversified, and low-cost T. Rowe Price funds representing a broad range of asset classes.',
            title: 'Select Funds | Mutual Funds | T. Rowe Price'
        }
    },
    {
        pagename: 'IClass Shares',
        data: {
            desc:
                'Get detailed investment information on I Class Mutual Funds, Morningstar Ratings, standardized returns, fees and expenses.',
            title: 'IClass Shares | Mutual Funds | T. Rowe Price'
        }
    },
    {
        pagename: 'Closed Funds',
        data: {
            desc:
                'Get detailed investment information on Closed T. Rowe Price Mutual Funds, Morningstar Ratings, standardized returns, fees and expenses.',
            title: 'Closed Funds | Mutual Funds | T. Rowe Price'
        }
    }
];

const getMetaData = (filterName, filterType) => {
    if (find(filterType, { pagename: filterName })) {
        return find(filterType, { pagename: filterName });
    }
    return null;
};

const DirectlandingPageMeta = (pagename) => (
    <React.Fragment>
        <Helmet>
            <title>{getMetaData(pagename.pagename, metaData).data.title}</title>
            <meta
                name="DESCRIPTION"
                content={getMetaData(pagename.pagename, metaData).data.desc}
            />
            <meta name="author" content="Trailblazers" />
            <meta name="robots" content="index,follow" />
        </Helmet>
    </React.Fragment>
);

export default DirectlandingPageMeta;
